import { useQuery } from '@tanstack/react-query';

import { fetchTeamTags } from '@/api/v4/team-tags.api';
import { QueryKey } from '@/config/query-client';

import { teamIdState } from '../../team.state';
import { useAtomValue } from 'jotai';

export const useTeamTags = () => {
  const teamId = useAtomValue(teamIdState);
  return useQuery({
    queryKey: [QueryKey.TeamTags, teamId],
    queryFn: () => {
      if (!teamId) return null;

      return fetchTeamTags(teamId);
    },
    enabled: !!teamId,
  });
};
